/**
 * Copyright (c) PitchHub, in. All rights reserved.
 * This file is covered by the PitchHub.com software use license.
 * Copyright date note stated due to Berne Convention for the Protection of Literary and Artistic Works
 *
 * @fileOverview Constants
 */

export const apis = {
  oauth: {
    token: 'unauthorized/oauth/token',
  },
  register: {
    new: 'unauthorized/users',
    resend: 'unauthorized/users/verify-email',
  },
  security: {
    testRecord: '/authorized/test/test-record',
  },
  users: {
    current: 'authorized/users/current',
    id: 'authorized/users',
    list: 'authorized/users',
    record: 'authorized/users',
  },
  organizations: {
    list: 'authorized/organizations',
  },
  credits: {
    list: 'authorized/credits',
    adjustCredits: (userId: number) => `/authorized/users/${userId}/credits/adjustment`,
    transferCredits: (userId: number) => `/authorized/users/${userId}/credits/transfer`,
  },
  customer: {
    list: 'authorized/customers',
  },
  promotionCode: {
    list: 'authorized/promotion-codes',
    verify: 'unauthorized/promotion-codes/validate-with-product',
  },
  video: {
    list: 'authorized/videos',
  },
  videoMenu: {
    list: 'authorized/video-menus',
    record: 'authorized/videos',
  },
  project: {
    list: 'authorized/projects',
  },
  product: {
    list: 'authorized/products',
    publicList: 'unauthorized/products',
  },
  passwordRecover: {
    recover: 'unauthorized/users/password-recover',
    reset: 'unauthorized/users/password-recover-change',
  },
  order: {
    list: 'authorized/orders',
    cancel: (orderId: number) => `/authorized/orders/${orderId}/cancel`,
  },
  userPermissions: {
    default: 'authorized/user-permissions',
  },
  lists: 'authorized/lists',
  scenes: {
    list: 'authorized/scenes',
  },
  documents: {
    default: '/authorized/documents',
  },
  articles: {
    default: '/authorized/articles',
    uploadVideoFromUrl: (videoId: number) => `/authorized/videos/${videoId}/upload-from-url`,
  },
  verificationCode: {
    generateCode: '/authorized/users/current/phone/generate-verification-code',
    verifyCode: '/authorized/users/current/phone/verify',
  },
  billing: {
    checkout: (userId: number) => `/authorized/users/${userId}/checkout`,
    plan: (userId: number) => `/authorized/users/${userId}/plan`,
    paymentMethod: (userId: number) => `/authorized/users/${userId}/payment-method`,
    invoices: (userId: number) => `authorized/users/${userId}/invoices`,
    createCustomInvoice: (userId: number) => `/authorized/users/${userId}/invoices`,
    checkoutReadyProducts: (userId: number) => `/authorized/users/${userId}/checkout-ready`,
    updatePromotionCodeInActiveSubscription: (userId: number) => `/authorized/users/${userId}/promotion-code`,
  },
} as const;

export const urlsForRedirect = [
  apis.users.list,
  apis.organizations.list,
  apis.customer.list,
  apis.video.list,
  apis.videoMenu.list,
  apis.project.list,
  apis.promotionCode.list,
  apis.order.list,
];
